var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-container" },
    [
      _c(
        "div",
        { staticClass: "loginInner" },
        [
          _c("div", { staticClass: "login-bg" }, [
            _c("h4", { staticClass: "info" }, [_vm._v("您好")]),
            _vm._v(" "),
            _c("h5", [_vm._v(_vm._s(_vm.nowDate))])
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              ref: "loginForm",
              staticClass: "login-form",
              attrs: { autocomplete: "on", "label-position": "left" }
            },
            [
              _c("div", { staticClass: "title-container" }, [
                _c("h3", { staticClass: "title" }, [_vm._v("竞赛材料提交系统")])
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-top": "40px" },
                  attrs: { label: "手机号", prop: "username" }
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "on",
                      placeholder: "输入手机号",
                      "prefix-icon": "el-icon-mobile-phone",
                      tabindex: "1"
                    },
                    on: { input: _vm.trimPhone },
                    model: {
                      value: _vm.phone,
                      callback: function($$v) {
                        _vm.phone = $$v
                      },
                      expression: "phone"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: "Caps lock is On",
                    manual: "",
                    placement: "right"
                  },
                  model: {
                    value: _vm.capsTooltip,
                    callback: function($$v) {
                      _vm.capsTooltip = $$v
                    },
                    expression: "capsTooltip"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column"
                      },
                      attrs: { label: "验证码", prop: "vaicode" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center"
                          }
                        },
                        [
                          _c("el-input", {
                            key: "text",
                            staticClass: "vaiCodeinput",
                            attrs: {
                              autocomplete: "on",
                              name: "vaicode",
                              placeholder: "验证码",
                              "prefix-icon": "el-icon-menu",
                              tabindex: "3"
                            },
                            model: {
                              value: _vm.code,
                              callback: function($$v) {
                                _vm.code = $$v
                              },
                              expression: "code"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "vaiCode" },
                            [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "preventRepeatClick",
                                      rawName: "v-preventRepeatClick"
                                    }
                                  ],
                                  staticClass: "primary",
                                  staticStyle: {
                                    "margin-left": "30px",
                                    "letter-spacing": "2px"
                                  },
                                  attrs: {
                                    plain: "",
                                    round: "",
                                    type: "primary"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.getCode(_vm.num)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.num || "获取验证码"))]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "button_wrap" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "preventRepeatClick",
                        rawName: "v-preventRepeatClick"
                      }
                    ],
                    staticClass: "login-btn",
                    on: { click: _vm.handleLogin }
                  },
                  [_vm._v("登录")]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.activietitle
        ? _c("div", { staticClass: "login-title" }, [
            _vm._v(_vm._s(_vm.activietitle))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "bottom" }, [
        _c("div", { staticClass: "login-info" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "copyright_wrap" }, [
            _c("p", { staticClass: "copy-icp" }, [
              _vm._v(
                "\n          © " + _vm._s(_vm.getYear) + "立智博学:\n          "
              ),
              _c(
                "a",
                {
                  attrs: { href: "https://beian.miit.gov.cn", target: "_blank" }
                },
                [_vm._v("京ICP备19019603号-2")]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.errorDialogVisible
        ? _c(
            "el-dialog",
            {
              attrs: {
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                "show-close": false,
                visible: _vm.errorDialogVisible,
                center: "",
                width: "35%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.errorDialogVisible = $event
                }
              }
            },
            [
              _c("error-view", {
                attrs: {
                  buttonTitle: _vm.errorButtonTitle,
                  text: _vm.errorMessage
                },
                on: { confirm: _vm.confirm }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "desc" }, [
      _vm._v(
        "\n        1.请参赛选手使用报名时填写的手机号进行登录，如遗忘请联系赛事组织者或领队人员询问\n        "
      ),
      _c("br"),
      _vm._v(
        "2.请各参赛选手在规定时间内，通过本系统提交竞赛材料，材料一经提交，组委会不接受\n        任何形式的更改或调换，逾期未报送者，视作放弃参赛资格\n        "
      ),
      _c("br"),
      _vm._v(" "),
      _c("div", { staticClass: "browser" }, [
        _vm._v("\n          3.推荐使用\n          "),
        _c(
          "a",
          {
            attrs: { href: "https://www.google.cn/chrome/", target: "_blank" }
          },
          [_vm._v("Google 浏览器、")]
        ),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: "http://browser.360.cn/", target: "_blank" } },
          [_vm._v("360浏览器（极速模式）、")]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href:
                "https://dlie.sogoucdn.com/se/sogou_explorer_11.0.1_0218.exe",
              target: "_blank"
            }
          },
          [_vm._v("搜狗浏览器、")]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href:
                "https://www.microsoft.com/zh-cn/edge?icid=SSM_AS_Promo_Other_Edge",
              target: "_blank"
            }
          },
          [_vm._v("Edge浏览器")]
        ),
        _vm._v("\n          等主流浏览器访问\n        ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37dfd6fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37dfd6fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/index.vue
// module id = null
// module chunks = 